/// <amd-module name="Search/Shared/Base/Sources/SearchOrgButtonAvailabilityHelper" />

import { SearchOrgButtonEnabledSource } from "Search/Shared/Base/Sources/SearchOrgButtonEnabledSource";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPageService } from "VSS/Platform/Page";

export function isSearchOrgButtonEnabled(pageContext: IVssPageContext): boolean {
	const searchOrgLinkEnabledSource = new SearchOrgButtonEnabledSource();
	const pageData = pageContext.getService<IVssPageService>("IVssPageService").getData();

	let isButtonEnabled: boolean = false;

	if (pageData) {
		isButtonEnabled = pageData.isHosted && searchOrgLinkEnabledSource.isSearchOrgButtonEnabled(pageContext);
	}

	return isButtonEnabled;
}
